import { DialogMemberViewModel } from '@common/model/dialog/dialogMemberViewModel';
import { useSelector } from 'react-redux';
import { EntityId } from '@reduxjs/toolkit';
import { currentDialogIdSelector } from './store/currentDialogSelectors';
import { currentDialogMemberSelector } from './store/selectors';
import { useCurrentUserContext } from './user.ctx';
import { DialogReducerStateShape } from './store/dialog';

export const useCurrentDialogMember = (props: { dialogId?: EntityId } = {}): DialogMemberViewModel | undefined => {
  const provider = useCurrentUserContext();
  const currentDialogId = useSelector(currentDialogIdSelector);
  const dialogId = props.dialogId ?? currentDialogId;
  const user = provider.getUser();
  const selectorMember = useSelector((state: DialogReducerStateShape) => {
    return user && dialogId ? currentDialogMemberSelector(state, { dialogId, user }) : undefined;
  });

  return selectorMember;
};
